import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const ArrowBigDown = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M4 16C4 13.794 5.794 12 8 12C9.042 12 10.029 12.399 10.779 13.123C10.786 13.129 10.792 13.136 10.798 13.142L12 14.368V8.00098C12 5.79498 13.794 4.00098 16 4.00098C18.206 4.00098 20 5.79498 20 8.00098V14.366L21.165 13.179C21.916 12.428 22.947 12.001 24 12.001C26.206 12.001 28 13.795 28 16.001C28 17.054 27.573 18.085 26.828 18.83L18.828 26.83C18.083 27.574 17.052 28.002 15.999 28.002C14.946 28.002 13.915 27.575 13.171 26.83L5.171 18.83C4.426 18.085 4 17.054 4 16.001V16ZM9.38 14.553C9.006 14.196 8.517 14 8 14C6.897 14 6 14.897 6 16C6 16.526 6.213 17.042 6.586 17.414L14.586 25.414C14.958 25.786 15.474 26 16 26C16.526 26 17.042 25.787 17.414 25.414L25.414 17.414C25.786 17.042 26 16.526 26 16C26 14.897 25.103 14 24 14C23.474 14 22.958 14.213 22.586 14.586L19.714 17.513C19.43 17.803 18.998 17.892 18.622 17.738C18.246 17.584 18 17.218 18 16.812V7.99998C18 6.89698 17.103 5.99998 16 5.99998C14.897 5.99998 14 6.89698 14 7.99998V16.815C14 17.221 13.754 17.587 13.378 17.741C13.002 17.895 12.57 17.806 12.286 17.516L9.38 14.554V14.553Z" />
	</svg>
);

export default ArrowBigDown;
